import { SearchOutlined } from '@mui/icons-material'
import { InputBase, Paper, styled } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface MobileTableSearchProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  ariaLabel: string
}

const SearchContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '40px',
  padding: theme.spacing(0, 3),
  gap: theme.spacing(2),
  borderRadius: theme.spacing(7),
  fontSize: 16,
  // Focus styles when input inside is focused
  '&:focus-within': {
    borderColor: theme.palette.secondary.main,
  },
}))

const SearchIcon = styled(SearchOutlined)(({ theme }) => ({
  color: theme.palette.neutralLight[900],
  fontSize: 'inherit',
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: theme.palette.neutralLight[700],
}))

export const MobileTableSearch: React.FC<MobileTableSearchProps> = ({ value, onChange, ariaLabel }) => {
  const { t: tShared } = useTranslation('shared')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  }

  return (
    <SearchContainer>
      <SearchIcon />
      <StyledInputBase
        placeholder={tShared('search.placeholder')}
        value={value}
        onChange={handleChange}
        aria-label={ariaLabel}
        data-testid="mobile-table-search"
      />
    </SearchContainer>
  )
}
